import { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import Linkedin from "../assests/linkedin.svg";
import Mail from "../assests/Gmail_Logo.svg";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.company.trim()) newErrors.company = 'Company is required';
    if (!formData.message.trim()) newErrors.message = 'Message is required';

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const templateParams = {
        ...formData,
        title: formData.company || 'No Title',
      };

      emailjs.send(
        'service_kajon0l',
        'template_g4ro23o',
        templateParams,
        'Xj7msaPxpryXe5BI4'
      ).then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatusMessage('✅ Message sent successfully!');
        setFormData({ name: '', email: '', company: '', message: '' });
      }).catch((err) => {
        console.error('FAILED...', err);
        setStatusMessage(`❌ Failed to send message: ${err.text || err.message || 'Unknown error'}`);
      });
    }
  };

  return (
    <section className="py-20 px-6 bg-black text-white overflow-hidden relative">
      {/* Background Animation */}
      <motion.div
        className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-indigo-400 opacity-20 blur-3xl z-0"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 160, ease: 'linear' }} 
      />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="relative z-10 max-w-3xl mx-auto bg-white/70 backdrop-blur-xl rounded-3xl shadow-2xl p-10 border border-white/30 text-black"
      >
        {/* 🔹 Stylish Company Info at the Top */}
        <div className="bg-white/80 rounded-xl shadow-md p-6 mb-10">
          <h3 className="text-2xl font-bold text-indigo-700 mb-4 text-center">
            📇 Our Company Information
          </h3>
          <ul className="space-y-3 text-gray-800 text-sm sm:text-base">
            <li className="flex items-start gap-2">
              <span className="text-lg">🏢</span>
              <span><strong>Company:</strong> Prisu Experts</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-lg">🧑‍💼</span>
              <span><strong>Founder:</strong> Sujit Kumar Raj</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-lg">📞</span>
              <span><strong>Mobile:</strong> +91 91021 63705</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-lg">✉️</span>
              <span><strong>Email:</strong> hrprisuexperts@gmail.com</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-lg">📍</span>
              <span><strong>Address:</strong> Anisabas,Patna,Bihar India 800002</span>
            </li>
          </ul>
        </div>

        {/* 🔸 Contact Form Section */}
        <h2 className="text-3xl font-extrabold text-center mb-6 tracking-tight font-orbitron">
          Let’s Build Smarter AI Together
        </h2>
        <p className="text-lg mb-10 text-center">
          Reach out to explore how Prisu Experts can support your AI goals with precision and scale.
        </p>

        <form className="space-y-6" onSubmit={handleSubmit}>
          {[
            { name: 'name', type: 'text', placeholder: 'Your Name', icon: '👤' },
            { name: 'email', type: 'email', placeholder: 'Email Address', icon: '📧' },
            { name: 'company', type: 'text', placeholder: 'Company Name', icon: '🏢' }
          ].map(({ name, type, placeholder, icon }) => (
            <div key={name} className="relative">
              <input
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                placeholder=" "
                autoComplete="off"
                className={`peer w-full px-4 py-3 pl-10 border rounded-lg bg-white/80 focus:outline-none focus:ring-2 transition
                  ${errors[name] ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-indigo-500'}`}
              />
              <label
                htmlFor={name}
                className="absolute left-10 top-8 text-gray-500 text-base transition-all
                  peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:top-8 peer-focus:text-base peer-focus:text-indigo-600"
              >
                {placeholder}
              </label>
              <span className="absolute left-3 top-3 text-gray-400 text-lg">{icon}</span>
              {errors[name] && <p className="text-red-500 text-sm mt-1">{errors[name]}</p>}
            </div>
          ))}

          <div className="relative">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder=" "
              autoComplete="off"
              className={`peer w-full px-4 py-3 pl-10 border rounded-lg bg-white/80 h-32 resize-none focus:outline-none focus:ring-2 transition
                ${errors.message ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-indigo-500'}`}
            />
            <label
              htmlFor="message"
              className="absolute left-10 top-8 text-gray-500 text-base transition-all
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                peer-focus:top-8 peer-focus:text-base peer-focus:text-indigo-600"
            >
              Your Message
            </label>
            <span className="absolute left-3 top-3 text-gray-400 text-lg">💬</span>
            {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white font-semibold py-3 rounded-lg hover:bg-indigo-700 transition"
          >
            Send Message →
          </button>

          {statusMessage && (
            <p className={`text-sm mt-4 text-center font-medium ${statusMessage.startsWith('✅') ? 'text-green-700' : 'text-red-600'}`}>
              {statusMessage}
            </p>
          )}
        </form>

        <div className="mt-10 text-center">
          <p className="text-gray-700 mb-4">or connect via</p>
          <div className="flex justify-center gap-6 text-2xl text-indigo-600">
            <motion.a
              href="https://www.linkedin.com/company/prisu-experts/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -5, scale: 1.2 }}
              animate={{ y: [0, -3, 0], transition: { repeat: Infinity, duration: 2 } }}
            >
              <img src={Linkedin} alt="LinkedIn" className="w-8 h-8" />
            </motion.a>

            <motion.a
              href="mailto:hrprisuexperts@gmail.com"
              whileHover={{ y: -5, scale: 1.2 }}
              animate={{ y: [0, -3, 0], transition: { repeat: Infinity, duration: 2 } }}
            >
              <img src={Mail} alt="Email" className="w-8 h-8" />
            </motion.a>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
